import { canShowSketchPropertySection, registerPropertyManagerSection } from '@/core';
import SketchOffsetPropertySection from '@/components/editor/property-manager/sketch-offset/SketchOffsetPropertySection.vue';

registerPropertyManagerSection({
  id: 'sketch-offset',
  title: '等距实体',
  order: 17,
  component: SketchOffsetPropertySection,
  exclusive: true,
  actions: {
    confirm: true,
    cancel: true,
  },
  isApplicable: (context) => {
    return canShowSketchPropertySection(
      context,
      context.isSketchActive
        && context.activeCommand === 'sketch-offset-entities',
    );
  },
  onConfirm: (context) => {
    // 执行最终的 偏移结果草图对象生成
    context.generateAndExitSketchOffsetWorkflow();
  },
  onCancel: (context) => {
    // 直接退出等距实体模式
    context.clearSketchOffsetWorkflow();
  },
});
